// The base no-unused-vars rule does not see type-only uses.
/* eslint no-unused-vars: "off", "@typescript-eslint/no-unused-vars": "warn" */
import React from 'react';
import { ArcRowsUpload } from '../../Common/ArcRows';
import { RetryAlert } from '../../Common/ErrorMessages';
import { formatLocale, useLocales } from '../../../utils/locales';
import { LoadClient } from '../ScopingModels/useLoaded';
import * as goldenDatasets from './goldenDatasets';

export const TEMPLATE_URL = `${process.env.PUBLIC_URL || ''}/golden-dataset-template.xlsx`;

interface GoldenDatasetRowsUploadProps {
  apiClient: LoadClient;
  // Rejects with the API error when the replace fails.
  onReplace: (rows: goldenDatasets.UploadedRow[]) => Promise<unknown>;
  onReload: () => void;
}

/** Replaces every row of a dataset with an uploaded spreadsheet's, checked against the locales. */
const GoldenDatasetRowsUpload = ({
  apiClient,
  onReplace,
  onReload,
}: GoldenDatasetRowsUploadProps): JSX.Element => {
  const locales = useLocales(apiClient, goldenDatasets.describeError);
  return (
    <ArcRowsUpload
      list={goldenDatasets.datasetRows}
      locales={locales.locales}
      display={formatLocale}
      idPrefix="goldenDatasetRows"
      title="Upload rows"
      description="Fill in the template with one row per arc in your base rates. The upload replaces every row."
      templateUrl={TEMPLATE_URL}
      emptyMessage="The file has no rows below the header row."
      ready
      onCreate={onReplace}
      submitLabel="Replace rows"
      conflictHeader={goldenDatasets.UPLOAD_CONFLICT_HEADER}
      onReload={onReload}
    >
      {locales.errors.length > 0 && (
        <RetryAlert
          id="goldenDatasetLocalesError"
          header="Could not load the locales; uploading is unavailable"
          messages={locales.errors}
          retryId="retryGoldenDatasetLocales"
          onRetry={locales.reload}
        />
      )}
    </ArcRowsUpload>
  );
};

export default GoldenDatasetRowsUpload;
